<!-- The navigation that will be shown depending on the calendar resolution
  this quick navigation is used to move around different periods in the calendar, for example: change month, change year.
-->
<ui-quick-navigation
  [selected]="selected"
  [active]="active"
  [type]="type"
  [resolution]="resolution"
  (activeChange)="onActiveChange($event)"
  (resolutionChange)="onResolutionChange($event)"
></ui-quick-navigation>
<ui-month
  [hidden]="resolution !== 'day'"
  [max]="max"
  [min]="min"
  [active]="active"
  [selected]="selected"
  [disabledDateRanges]="disabledDateRanges"
  (selectDayEvent)="selectRange($event)"
></ui-month>
<ui-week
  [hidden]="resolution !== 'week'"
  [max]="max"
  [min]="min"
  [active]="active"
  [selected]="selected"
  [disabledDateRanges]="disabledDateRanges"
  (selectedWeekEvent)="selectRange($event)"
></ui-week>
<ui-months
  [hidden]="resolution !== 'month'"
  [max]="max"
  [min]="min"
  [active]="active"
  [selected]="selected"
  [disabledDateRanges]="disabledDateRanges"
  (selectMonthEvent)="selectRange($event)"
></ui-months>
<ui-years
  [hidden]="resolution !== 'year'"
  [max]="max"
  [min]="min"
  [active]="active"
  [selected]="selected"
  [disabledDateRanges]="disabledDateRanges"
  (selectYearEvent)="selectRange($event)"
></ui-years>
